import React from 'react';
import { Accordion, Button } from 'react-bootstrap';

import instance from "../../../services/api";

const Course = ({ title, subModules }) => {

    const handleDownload = async ( fileName ) => {
        try {
            const response = await instance.get(`/docs/${encodeURIComponent(fileName)}`, { responseType: 'blob' });

            // Create a blob object from the response data
            const blob = new Blob([response.data], { type: response.headers['content-type'] });

            // Create a link element to trigger the download
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);

            const dispositionHeader = response.headers['content-disposition'] || '';
            const dispositionMatch = dispositionHeader.match(/filename="?([^";]+)"?/i);
            link.download = dispositionMatch ? dispositionMatch[1] : fileName;

            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error('Document download failed:', error);
            window.alert('Unable to download this file right now. Please try again shortly.');
        }
    };

    return (
        <Accordion defaultActiveKey="0" className="page-section">
            <h4 className="fw-bold mb-3">{title}</h4>
            {subModules.map((subModule, index) => {
                const moduleDocFiles = Array.isArray(subModule.docFiles) ? subModule.docFiles : [];

                return (
                    <Accordion.Item eventKey={index} key={index}>
                        <Accordion.Header>{subModule.title}</Accordion.Header>
                        <Accordion.Body>
                            <iframe title={index} src={subModule.slidesLink} width="100%" height="880" allowFullScreen={true} mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
                            {moduleDocFiles.map((docFile, pairIndex) => (
                                <React.Fragment key={`${index}-doc-file-${pairIndex}`}>
                                    {docFile.docLink && (
                                        <iframe
                                            title={`${index}-doc-${pairIndex}`}
                                            src={docFile.docLink}
                                            width="100%"
                                            height="800"
                                        ></iframe>
                                    )}
                                    {docFile.fileName && (
                                        <Button
                                            variant="primary"
                                            className="mt-2 me-2"
                                            onClick={() => handleDownload(docFile.fileName)}
                                            download
                                        >
                                            {moduleDocFiles.length > 1 ? `Download ${pairIndex + 1}` : "Download"}
                                        </Button>
                                    )}
                                </React.Fragment>
                            ))}
                        </Accordion.Body>
                    </Accordion.Item>
                );
            })}
        </Accordion>
    );
};

export default Course;